// apps/web/src/features/commercial-proposals/characteristics.ts
//
// @aiPurpose round-trip between the editor's "one per line" textarea and the
//   ordered `characteristics: string[]` of the shared content (#1198).
//   Mirrors the prototype textarea: each non-empty line is one characteristic
//   and display order is preserved.
// @aiInvariant parsing trims each line and drops blank lines but NEVER
//   reorders; serializing joins with `\n`. The two are inverses for any
//   already-normalized array.

/** Textarea text -> ordered, trimmed, non-empty characteristic lines. */
export function parseCharacteristicsText(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
}

/** Ordered characteristic lines -> textarea text (one per line). */
export function serializeCharacteristics(lines: readonly string[]): string {
  return lines.join('\n');
}
